// import SettingsService from 'services/settings'
import { mapState, mapMutations } from 'vuex'
import { getChannelImagePath } from 'helpers/images'

export default {
  props: {
    item: Object
  },
  data: function () {
    return {
      processing: false
    }
  },
  computed: {
    ...mapState({
      selectedChannel: state => state.guide.selectedChannel
      // tvFavorites: state => state.guide.tvFavorites
    }),
    selectedClass: function () {
      return this.item.id === this.selectedChannel.id
    }
    // bgImage: function () {
    //   return `https://${process.env.IS.playerSubdomain}.${process.env.IS.resourceDomain}/${process.env.IS.serviceProvider}/images/channels/app/overlay/` + this.item.id + '.png'
    //   return process.env.IMAGES + this.item.images[0].path
    // },
    // isFavorite: function () {
    //   return this.tvFavorites.indexOf(this.item.id.toString()) > -1
    // }
  },
  methods: {
    ...mapMutations([
      'UPDATE_SELECTED_CHANNEL'
    ]),
    getChannelImagePath: function (images, mode) {
      return getChannelImagePath(images, mode)
    }
    // updateFavorite: function () {
    //   if (this.isFavorite) {
    //     // remove
    //     this.removeItemToTvFavorites(this.item.id.toString())
    //     SettingsService.removeFavorite(process.env.favoriteTypes.tv, this.item.id)
    //       .then((response) => {
    //         this.updateTvFavorites(response.data[process.env.favoriteTypes.tv])
    //       })
    //       .finally(() => {
    //         this.processing = false
    //       })
    //   } else {
    //     // add
    //     this.addItemToTvFavorites(this.item.id.toString())
    //     SettingsService.addFavorite(process.env.favoriteTypes.tv, this.item.id)
    //       .then((response) => {
    //         this.updateTvFavorites(response.data[process.env.favoriteTypes.tv])
    //       })
    //       .finally(() => {
    //         this.processing = false
    //       })
    //   }
    // }
  },
  eventActionOptions: {
    hasStartOver: false,
    hasFavorite: true
  }
}



// WEBPACK FOOTER //
// ./src/containers/mixins/ChannelMixin.js